import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=874e5f16&"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports